import SvgRemoveButton from "../../icons/SvgClose";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}


export function ButtonClose ({ children, className, onClick, type, ...props}: Props) {
  return (
      <button
          className={`${className}`}
          {...props}
          onClick={onClick}
          type="button"
          >
          {children}
          <SvgRemoveButton />
      </button>
 
);
};



export default ButtonClose;
